import customerAPI from '../../api/customer/general'
import customerDetailsAPI from '../../api/customer/profile'
import summary from '../../api/customer/summary'
import consultation from '../../api/consultation'
import medicationsAPI from '../../api/customer/medication'
import StoreInit from '../../api/initialise_store'
import HealthParameters from '../../api/customer/health_parameters'
import labDocument from '../../api/customer/document'
import prescriptionAPI from '../../api/customer/prescription'
import { convertHeightToFeetInches } from '../../components/common/snackbar/helpers'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
Vue.use(VueToast)

// State
const state = {
  initiated: false,
  activeOfflineConsults: [],
  activeCustomerId: null,
  searchResult: [],
  drugs: [],
  selectedTests: []
}

// Getters
const getters = {
  getActiveOfflineConsults: function () {
    return state.activeOfflineConsults
  },
  searchResult: function () {
    return state.searchResult
  },
  getDrugs () {
    let index = state.drugs.findIndex((ele) => ele.customerId === state.activeCustomerId)
    if (index > -1) {
      return state.drugs[index].drugs
    } else {
      return []
    }
  },
  getLabTests () {
    let index = state.selectedTests.findIndex((test) => test.customerId === state.activeCustomerId)
    if (index > -1) {
      return state.selectedTests[index].tests
    } else {
      return []
    }
  }
}

// Actions
const actions = {
  init ({commit, state, dispatch, rootState}) {
    StoreInit.fetchActiveOfflineConsultationsDetails().then(response => {
      if (response.status === 200) {
        commit('setUpDetails', response.body.active_offline_consultations)
        if (state.activeOfflineConsults.length > 0) {
          dispatch('switchTo', state.activeOfflineConsults[0].channelId)
        } else {
          dispatch('switchTo', null)
        }
      }
    })
  },
  fetchCustomers: function ({ commit, state, dispatch }, query) {
    customerAPI.search_customer(query)
    .then(response => {
      if (response.status === 200) {
        commit('updateSearchResult', response.body.customers)
      }
    })
  },
  addNewCustomer: function ({ commit, state, dispatch }, customer) {
    commit('addNewCustomer', customer)
    dispatch('switchTo', customer.customer_id)
  },
  addAptConsultation: function ({ commit, state, dispatch }, appointment) {
    commit('addAptConsultation', appointment)
    dispatch('switchTo', appointment.ek_id)
    dispatch('fetchConsultation', appointment)
  },
  addEnquireNowConsult: function ({ commit, state, dispatch }, notification) {
    commit('addEnquireNowConsult', notification)
    dispatch('switchTo', notification.customer_id)
    setTimeout(() => {
      dispatch('configuration/setRightPaneTab', 'notification', { root: true })
    }, 1600)
  },
  storeLabTests ({state, commit}, { tests, customerId }) {
    commit('storeLabTests', {tests, customerId})
  },
  fetchConsultation: function ({ commit, dispatch }, appointment) {
    consultation.getConsultation(appointment.consultation_id).then(response => {
      if (response.status === 200) {
        commit('updateConsultation', { channelId: state.activeCustomerId, consultation: response.body.consultation })
      }
    })
  },
  switchTo: function ({ commit, state, dispatch, rootState }, customerId) {
    commit('switchTo', customerId)
    if (customerId !== null) {
      dispatch('fetchCustomerProfile', customerId)
    }
  },
  fetchCustomerProfile ({commit, state}, customerId) {
    customerDetailsAPI.getCustomerDetails(customerId).then(response => {
      if (response.status === 200 && response.body.customer) {
        commit('updateCustomerDetails', {
          customerId: customerId,
          customerDetails: response.body.customer
        })
      }
    })
  },
  updateConsultation ({ commit, state, dispatch }, data) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === state.activeCustomerId)
    })
    if (patient.consultation.consultationId) {
      summary.saveSummaryDetails(data, patient.consultation.consultationId).then(response => {
        if (response.status === 200) {
          dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
          commit('updateConsultation', {channelId: state.activeCustomerId, consultation: response.body.consultation})
        } else {
          dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        }
      })
    } else {
      if (Object.keys(data)[0] === 'chief_compliant') {
        data.customer_id = state.activeCustomerId
        dispatch('createConsultation', data)
      } else {
        Vue.$toast.open({
          message: `Please add Chief complaint to create consultation`,
          type: 'error',
          position: 'top',
          queue: false
        })
        commit('updateConsultation', {channelId: state.activeCustomerId, consultation: {}})
      }
    }
  },
  updateHealthParameters ({commit, state, dispatch}, data) {
    HealthParameters.updateHealthParameters(data, state.activeCustomerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeCustomerId, healthParameters: response.body.customer_health_parameters })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  updateGeneralParameters ({commit, state, dispatch}, data) {
    HealthParameters.updateGeneralParameters({gender: data.gender, date_of_birth: data.date_of_birth}, state.activeCustomerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (Object.keys(response.body).length > 0) {
          commit('updateCustomerDetails', { customerId: state.activeCustomerId, customerDetails: {gender: response.body.gender, date_of_birth: response.body.date_of_birth} })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
    HealthParameters.updateHealthParameters({blood_group: data.blood_group}, state.activeCustomerId).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        if (response.body.customer_health_parameters.length > 0) {
          commit('updateHealthParameter', { channelId: state.activeCustomerId, healthParameters: response.body.customer_health_parameters })
        }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },

  uploadDocuments ({ commit, state, dispatch }, formData) {
    labDocument.uploadDocuments(formData).then(response => {
      if (response.status === 200) {
        // if (response.body.lab_reports) {
        commit('updateDocuments', {channelId: state.activeCustomerId, data: response.body})
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        // } else if (response.body.prescriptions) {
        //   commit('updatePrescriptions', {channelId: state.activeCustomerId, data: response.body.prescriptions})
        // }
      } else {
        dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
      }
    })
  },
  previewPrescription ({commit, state}, {data}) {
    prescriptionAPI.createPrescription(data, 'preview', state.activeCustomerId).then(response => {
      if (response.status === 200) {
        window.open(response.body.prescription_url, '_blank')
      }
    })
  },
  sendPrescription ({ commit, state }, { data }) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === state.activeCustomerId)
    })
    if (!patient.consultation.consultationId) {
      Vue.$toast.open({
        message: 'Please fill chief complaint to proceed',
        type: 'success',
        position: 'bottom-right',
        queue: true
      })
      return
    }
    prescriptionAPI.createPrescription(data, 'preview', state.activeCustomerId).then(response => {
      if (response.status === 200) {
        Vue.$toast.open({
          message: 'Prescription sent successfully',
          type: 'success',
          position: 'bottom-right',
          queue: false
        })
      }
    }).catch(function (e) {
      Vue.$toast.open({
        message: 'Something went wrong',
        type: 'error',
        position: 'bottom-right',
        queue: false
      })
    })
  },
  updateMedication ({commit, state}, data) {
    commit('updateMedication', {channelId: state.activeCustomerId, prescribedDrugs: data.prescribedDrugs})
  },
  updateCurrentMedication ({commit, state, dispatch}, medications) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === state.activeCustomerId)
    })
    if (patient) {
      medicationsAPI.update(patient.customerId, medications).then(resp => {
        if (resp.status === 200) {
          dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
          commit('updateCurrentMedication', {channelId: state.activeCustomerId, medications: resp.body.medications})
        } else {
          dispatch('toaster/setToaster', {status: true, type: 'error'}, { root: true })
        }
      })
    }
  },
  createConsultation ({ commit, state, dispatch }, data) {
    consultation.create(data).then(response => {
      if (response.status === 200) {
        dispatch('toaster/setToaster', {status: true, type: 'success'}, { root: true })
        commit('setupNewConsultation', { channelId: state.activeCustomerId, consultation: response.body.consultation })
      }
    }).catch(error => dispatch('toaster/setToaster', {status: true, type: 'error', message: error.body.message}, { root: true }))
  },
  endConsultation ({commit, state, rootState, dispatch}, {status, reasons}) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === state.activeCustomerId)
    })
    // when consultation ended with no consultation id, means it was never created in db.
    if (!patient.consultation.consultationId) {
      commit('removeConsultation', patient.consultation.consultationId)
      if (state.activeOfflineConsults.length > 0) {
        commit('switchTo', state.activeOfflineConsults[0].channelId)
      } else {
        commit('switchTo', null)
      }
    } else {
      consultation.endOfflineConsultation({consultation_id: patient.consultation.consultationId, status: status}).then(response => {
        if (response.status === 200 || response.status === 204) {
          if (response.body.message === 'Diagnosis can not be empty') {
            Vue.$toast.open({
              message: 'Diagnosis can not be empty',
              type: 'error',
              position: 'top',
              queue: false
            })
          } else {
            commit('removeDrugs', {customerId: patient.customerId})
            commit('removeConsultation', patient.consultation.consultationId)
            if (state.activeOfflineConsults.length > 0) {
              commit('switchTo', state.activeOfflineConsults[0].channelId)
            } else {
              commit('switchTo', null)
            }
            dispatch('pastOfflineConsultation/addToPastConsultation', { consult: patient }, { root: true })
            dispatch('toaster/setToaster', { status: true, type: 'success' }, { root: true })
            dispatch('pastOfflineConsultation/init', {}, { root: true })
          }
        }
      }).catch((error) => {
        console.log(error)
        dispatch('toaster/setToaster', { status: true, type: 'error' }, { root: true })
      })
    }
  }
}

// Mutations
const mutations = {
  setUpDetails (state, details) {
    for (let i = 0; i < details.length; i++) {
      let activeConsult = state.activeOfflineConsults.find(function (ele) {
        return (ele.customerId === details[i].customer_id)
      })
      if (!activeConsult) {
        let consult = {
          ablyEnabled: false,
          channelId: details[i].customer_id,
          customerId: details[i].customer_id,
          name: details[i].name,
          isFamilyDoctor: details[i].is_family_doctor,
          familyDoctor: {id: details[i].family_doctor.id, name: details[i].family_doctor.name},
          consultation: {
            chiefComplaint: details[i].chief_compliant,
            consultationId: details[i].consultation_id,
            provisionalDiagnosis: details[i].provisional_diagnois,
            summaryNotes: details[i].summary_notes,
            date: details[i].consultation_date,
            status: details[i].status,
            prescribedDrugs: details[i].prescribed_drugs
          },
          isOnline: false,
          details: {}
        }
        state.activeOfflineConsults.push(consult)
      } else {
        if (!activeConsult.consultation.consultationId) {
          let index = state.activeOfflineConsults.indexOf(activeConsult)
          state.activeOfflineConsults[index] = {
            ablyEnabled: false,
            channelId: details[i].customer_id,
            customerId: details[i].customer_id,
            name: details[i].name,
            isFamilyDoctor: details[i].is_family_doctor,
            familyDoctor: {id: details[i].family_doctor.id, name: details[i].family_doctor.name},
            consultation: {
              chiefComplaint: details[i].chief_compliant,
              consultationId: details[i].consultation_id,
              provisionalDiagnosis: details[i].provisional_diagnois,
              summaryNotes: details[i].summary_notes,
              date: details[i].consultation_date,
              status: details[i].status,
              prescribedDrugs: details[i].prescribed_drugs
            },
            isOnline: false,
            details: {}
          }
        }
      }
    }
    state.initiated = true
  },
  updateSearchResult: function (state, data) {
    state.searchResult = data
  },
  addNewCustomer: function (state, customer) {
    let consult = state.activeOfflineConsults.find(function (ele) {
      return (ele.customerId === customer.customer_id)
    })
    if (!consult) {
      let newConsult = {
        channelId: customer.customer_id,
        customerId: customer.customer_id,
        name: customer.first_name + ' ' + customer.last_name,
        isFamilyDoctor: false,
        familyDoctor: {id: null, name: ''},
        consultation: {
          chiefComplaint: '',
          consultationId: null,
          provisionalDiagnosis: '',
          summaryNotes: '',
          date: '',
          status: '',
          consultationType: 'audio',
          prescribedDrugs: []
        },
        isOnline: false,
        details: {}
      }
      state.activeOfflineConsults.unshift(newConsult)
      state.activeCustomerId = customer.customer_id
    } else {
      Vue.$toast.open({
        message: 'You have already selected this patient once',
        type: 'warning',
        position: 'top',
        queue: false
      })
    }
  },
  addAptConsultation (state, appointment) {
    let consult = state.activeOfflineConsults.find(function (ele) {
      return (ele.customerId === appointment.ek_id)
    })
    if (!consult) {
      let newConsult = {
        channelId: appointment.ek_id,
        customerId: appointment.ek_id,
        name: appointment.name,
        isFamilyDoctor: false,
        familyDoctor: {id: null, name: ''},
        consultation: {
          chiefComplaint: '',
          consultationId: appointment.consultation_id,
          provisionalDiagnosis: '',
          summaryNotes: '',
          date: '',
          status: '',
          consultationType: 'audio',
          prescribedDrugs: []
        },
        isOnline: false,
        details: {}
      }
      consultation.updateOfflineConsultation(appointment.consultation_id).then((response) => {
        if (response.status === 200) {
          state.activeOfflineConsults.unshift(newConsult)
          state.activeCustomerId = appointment.ek_id
        }
      })
      .catch(() => {
        Vue.$toast.open({
          message: 'Something went wrong',
          type: 'error',
          position: 'top',
          queue: false
        })
      })
    } else {
      Vue.$toast.open({
        message: 'Already have an ongoing offline consultation for this patient',
        type: 'warning',
        position: 'top',
        queue: false
      })
    }
  },
  addEnquireNowConsult (state, notification) {
    let consult = state.activeOfflineConsults.find(function (ele) {
      return (ele.customerId === notification.customer_id)
    })
    if (!consult) {
      let newConsult = {
        channelId: notification.customer_id,
        customerId: notification.customer_id,
        name: notification.details.customer_name,
        isFamilyDoctor: false,
        familyDoctor: {id: null, name: ''},
        consultation: {
          chiefComplaint: '',
          consultationId: null,
          provisionalDiagnosis: '',
          summaryNotes: '',
          date: '',
          status: '',
          consultationType: 'audio',
          prescribedDrugs: []
        },
        isOnline: false,
        details: {}
      }
      state.activeOfflineConsults.unshift(newConsult)
      state.activeCustomerId = notification.ek_id
    } else {
      Vue.$toast.open({
        message: 'Already have an ongoing offline consultation for this patient',
        type: 'warning',
        position: 'top',
        queue: false
      })
    }
  },
  switchTo (state, customerId) {
    state.activeCustomerId = customerId
  },
  // Updates Customer Details
  updateCustomerDetails (state, {customerId, customerDetails}) {
    let consult = state.activeOfflineConsults.find(function (ele) {
      return (ele.customerId === customerId)
    })
    let index = state.activeOfflineConsults.indexOf(consult)
    if (index > -1) {
      if (customerDetails.family_doctor && Object.keys(customerDetails.family_doctor).length === 0 && customerDetails.family_doctor.constructor === Object) {
        state.activeOfflineConsults[index].isFamilyDoctor = false
      } else {
        state.activeOfflineConsults[index].isFamilyDoctor = true
        state.activeOfflineConsults[index].familyDoctor = customerDetails.family_doctor
      }
      if (Object.keys(customerDetails).length === 2) {
        state.activeOfflineConsults[index].details.date_of_birth = customerDetails.date_of_birth
        state.activeOfflineConsults[index].details.gender = customerDetails.gender
      } else state.activeOfflineConsults[index].details = customerDetails
    }
  },
  setupNewConsultation (state, { channelId, consultation }) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeOfflineConsults.indexOf(patient)
    if (index > -1) {
      state.activeOfflineConsults[index].consultation.chiefComplaint = consultation.chief_compliant
      state.activeOfflineConsults[index].consultation.consultationId = consultation.id
    }
  },
  updateConsultation (state, { channelId, consultation }) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeOfflineConsults.indexOf(patient)
    if (index > -1) {
      state.activeOfflineConsults[index].consultation.chiefComplaint = consultation.chief_compliant
      state.activeOfflineConsults[index].consultation.provisionalDiagnosis = consultation.provisional_diagnois
      state.activeOfflineConsults[index].consultation.summaryNotes = consultation.summary_notes
      state.activeOfflineConsults[index].consultation.status = consultation.summary_status
    }
  },
  removeConsultation (state, consultationId) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.consultation.consultationId === consultationId)
    })
    let index = state.activeOfflineConsults.indexOf(patient)
    if (index > -1) {
      if (state.activeOfflineConsults.length > 1) {
        state.activeOfflineConsults.splice(index, 1)
      } else {
        state.activeOfflineConsults.splice(index, 1)
        state.activeOfflineConsults = []
      }
    }
  },
  updateHealthParameter (state, { channelId, healthParameters }) {
    let patient = state.activeOfflineConsults.find(ele => ele.channelId === channelId)
    if (!patient || !patient.details) return
    let patientHealthParameters = patient.details.health_parameters || {}
    healthParameters.forEach(({ question_tag: questionTag, result }) => {
      patientHealthParameters[questionTag] = result
      if (questionTag === 'height') {
        const [feet, inches] = convertHeightToFeetInches(result)
        patientHealthParameters.feet = feet
        patientHealthParameters.inches = inches
      }
    })
  },

  updateDocuments (state, { channelId, data }) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeOfflineConsults.indexOf(patient)
    if (index > -1) {
      state.activeOfflineConsults[index].details.documents.push(data)
    }
  },

  // updatePrescriptions (state, { channelId, data }) {
  //   let patient = state.activeOfflineConsults.find(function (ele) {
  //     return (ele.channelId === channelId)
  //   })
  //   let index = state.activeOfflineConsults.indexOf(patient)
  //   if (index > -1) {
  //     state.activeOfflineConsults[index].details.prescriptions = state.activeOfflineConsults[index].details.prescriptions.concat(data)
  //   }
  // },
  updateMedication (state, { channelId, prescribedDrugs }) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeOfflineConsults.indexOf(patient)
    if (index > -1) {
      state.activeOfflineConsults[index].consultation.prescribedDrugs = prescribedDrugs
      // state.activeOfflineConsults[index].details.prescribedDrugs = prescribedDrugs
    }
  },
  updateCurrentMedication (state, { channelId, medications }) {
    let patient = state.activeOfflineConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.activeOfflineConsults.indexOf(patient)
    if (index > -1) {
      state.activeOfflineConsults[index].details.medications = medications
    }
  },
  storeCurrentDrugs (state, { drug, customerId }) {
    drug.frequency = drug.frequency_unit !== null ? `${drug.frequency} a ${drug.frequency_unit}` : drug.frequency
    drug.route = drug.route ? drug.route.trim() : null
    drug.instructions = drug.instructions ? drug.instructions.trim() : null
    let index = state.drugs.findIndex((ele) => ele.customerId === customerId)
    if (index > -1) {
      state.drugs[index].drugs.push(drug)
    } else {
      let drugs = {
        drugs: [drug],
        customerId: customerId
      }
      state.drugs.push(drugs)
    }
  },
  removeDrugs (state, {customerId}) {
    let drugIndex = state.drugs.findIndex((ele) => ele.customerId === customerId)
    state.selectedTests = state.selectedTests.filter((ele) => ele.customerId !== customerId)
    if (drugIndex > -1) {
      state.drugs = state.drugs.filter((ele) => ele.customerId !== customerId)
    }
  },
  storeLabTests (state, { tests, customerId }) {
    let index = state.selectedTests.findIndex((test) => test.customerId === customerId)
    let selectedLabTests = {}
    let selectedTests = state.selectedTests
    if (index > -1) {
      state.selectedTests[index].tests = tests
    } else {
      selectedLabTests = {
        customerId: customerId,
        tests: tests
      }
      selectedTests.push(selectedLabTests)
      state.selectedTests = selectedTests
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/offline_consultation.js